import React from 'react';

export default class ScreenLock extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {passcode: '', invalid: false};
    this.inputRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.inputRef.current?.focus();
  }

  handleChange(e) {
    this.setState({passcode: e.target.value.replace(/\D/g, '').slice(0, 4), invalid: false});
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onUnlock(this.state.passcode)) {
      this.setState({passcode: '', invalid: false});
    } else {
      this.setState({passcode: '', invalid: true}, () => this.inputRef.current?.focus());
    }
  }

  render() {
    return (
      <div id="screen-lock" role="dialog" aria-modal="true" aria-label="Session locked">
        <form className="screen-lock-panel" onSubmit={this.handleSubmit}>
          <div className="screen-lock-mark">NO</div>
          <div className="screen-lock-kicker">NETWORK OPERATIONS</div>
          <h1>SESSION LOCKED</h1>
          <label htmlFor="screen-lock-code">ACCESS CODE</label>
          <input ref={this.inputRef} id="screen-lock-code" type="password" inputMode="numeric"
            autoComplete="one-time-code" value={this.state.passcode} onChange={this.handleChange}
            maxLength="4" aria-invalid={this.state.invalid} required />
          <button type="submit">UNLOCK</button>
        </form>
      </div>
    );
  }
}
